<template>
  <div
    v-if="
      selectedPlan !== null &&
        selectedPlan !== undefined &&
        planOptions !== null &&
        planOptions !== undefined
    "
  >
    <material-card
    :title="$t('globals.employers')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="work"
    >
      <pbas-data-table
        :exporters="$exporters"
        ref="employersTable"
        :dataProvider="employersProvider"
        :rowActions="employersRowActions"
        fileNamePrefix="employers"
        identifier="employersTable"
        @error="error = $event"
        :showSelect="false"
      ></pbas-data-table>
    </material-card>
    <div v-if="planOptions.HasStores">

      <material-card
      :title="$t('globals.stores')"
        :color="$vuetify.theme.themes.light.secondary"
        icon="store"
      >
        <pbas-data-table
          :exporters="$exporters"
          ref="storesTable"
          :dataProvider="storesProvider"
          fileNamePrefix="stores"
          identifier="storesTable"
          @error="error = $event"
          :showSelect="false"
        ></pbas-data-table>
      </material-card>
    </div>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import { ODataHeader, ODataString } from "pbas-vue-components";
import EmployersHeaders from "../headers/Employers";
import StoresHeaders from "../headers/Stores";
import StoresHeadersBillingImport from "../headers/StoresBillingImport";
import EmployersStoresHeaders from "../headers/EmployersStores";
import { translate2 } from "../trans2";
import { planSetter } from "../mixins/planSetter";

export default {
  components: {
    ErrorHandler,
  },
  mixins: [planSetter],
  data() {
    return {
      error: null,
      storeContactsHeaders: [
        new ODataHeader({
          type: new ODataString("Store/Current/Name"),
          sortable: true,
          visible: false,
          searchable: true,
          version: 1,
          allowVisibilityChange: false,
        }),
        new ODataHeader({
          title: "globals.store",
          type: new ODataString("Store/Current/Translations[]/Name", {
            getString: (item) => translate2(item.Store.Current, "Name"),
          }),
          sortable: true,
          visible: true,
          searchable: true,
          version: 1,
          orderByKey: "Name",
        }),
        new ODataHeader({
          type: new ODataString("Store/Current/Translations[]/LanguageCode"),
          sortable: false,
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          title: "Store Id",
          type: new ODataString("Store/Id"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          title: "StoreId",
          type: new ODataString("StoreId"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
      ],
      employerContactsHeaders: [
        new ODataHeader({
          type: new ODataString("Employer/Current/Name"),
          sortable: true,
          visible: false,
          searchable: true,
          version: 2,
          allowVisibilityChange: false,
        }),
        new ODataHeader({
          title: "globals.employer",
          type: new ODataString("Employer/Current/Translations[]/Name", {
            getString: (item) => translate2(item.Employer.Current, "Name"),
          }),
          sortable: true,
          visible: true,
          searchable: true,
          version: 1,
          orderByKey: "Name",
        }),
        new ODataHeader({
          type: new ODataString("Employer/Current/Translations[]/LanguageCode"),
          sortable: false,
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          type: new ODataString("Employer/Current/Translations[]/Id"),
          sortable: false,
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          type: new ODataString("Employer/Current/Translations[]/RefId"),
          sortable: false,
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          title: "Employer Id",
          type: new ODataString("Employer/Id"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          title: "EmployerId",
          type: new ODataString("EmployerId"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
      ],
      employersProvider: undefined,
      storesProvider: undefined,
      contactOwner: null,
      storesHeaders: StoresHeaders,
      employersRowActions: [
        {
          name: "viewEmployerDetails",
          icon: "visibility",
          title: "globals.view_details",
          handler: (item) =>
            this.$router.push({
              name: "employerDetails",
              params: {
                employerId: item.Id,
                planId: this.selectedPlan.Id,
              },
            }),
        },
      ],
      employersHeaders: null,
      allHeaders: EmployersHeaders,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions"]),
  },
  watch: {
    selectedPlan: {
      handler(v) {
        if (v && this.planOptions) {
          this.loadPlanData();
        }
      },
    },
    planOptions: {
      handler(v) {
        if (v && this.selectedPlan) {
          this.loadPlanData();
        }
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined && this.planOptions) {
      this.loadPlanData();
    }
  },
  methods: {
    async loadPlanData() {
      try {
        if (this.planOptions.HasStores) {
          this.employersHeaders = this.allHeaders.concat(
            EmployersStoresHeaders
          );
        } else {
          this.employersHeaders = this.allHeaders;
          this.contactOwner = "Employer";
        }
        if (this.planOptions.HasBillingImport) {
          this.storesHeaders = StoresHeadersBillingImport;
        }
        let employersUrl = "plans/" + this.selectedPlan.Id + "/employers";
        let storesUrl = "plans/" + this.selectedPlan.Id + "/stores";
        this.employersProvider = new PbasOData(
          this.$axiosHttp,
          employersUrl,
          this.employersHeaders
        );
        this.storesProvider = new PbasOData(
          this.$axiosHttp,
          storesUrl,
          this.storesHeaders
        );
      } catch (error) {
        this.error = error;
      }
    },
  },
};
</script>
